import React from 'react'
import { RxMixerHorizontal } from '@react-icons/all-files/rx/RxMixerHorizontal'
import type { Track } from 'types/track'
import { Flex } from 'components/ds'
import Submenu from 'components/track-actions/submenu/dropdown-submenu'
import ManageFilesAndFormats from './manage-files-formats'
import ManageNesting from './manage-nesting'

type Props = {
  disabled: boolean
  closeMenu: () => void
  manageTrackFormats: boolean
  manageNesting: boolean
  trackNestingEnabled: boolean
  track: Track
  isPhone: boolean
  isAudioFile: boolean
}

const ManageTrackOption = ({
  disabled,
  track,
  closeMenu,
  manageNesting,
  manageTrackFormats,
  trackNestingEnabled,
  isPhone,
  isAudioFile,
}: Props): React.ReactNode | null => {
  const links: React.ReactNode[] = []
  if (!isPhone || isAudioFile)
    links.push(
      <ManageNesting
        key="manage-nesting"
        closeMenu={closeMenu}
        disabled={disabled}
        track={track}
        manageNesting={manageNesting}
        trackNestingEnabled={trackNestingEnabled}
      />,
    )
  if (!track.video)
    links.push(
      <ManageFilesAndFormats
        key="manage-files-formats"
        manageTrackFormats={manageTrackFormats}
        closeMenu={closeMenu}
        disabled={disabled}
        track={track}
      />,
    )
  if (!links.length) return null
  return (
    <Submenu
      links={links}
      title={
        <Flex align="center" gap="2">
          <RxMixerHorizontal />
          Manage
        </Flex>
      }
    />
  )
}

export default ManageTrackOption
